export const TestIds = {
  toggleDetails: 'shared-view-dialog-toggle-details',
  copyDetails: 'shared-view-dialog-copy-details',
  loadDefault: 'shared-view-dialog-load-default',
  container: 'shared-view-error-details',
  reasonList: 'shared-view-error-details-reason-list',
  row: (rowId: string) => `shared-view-error-details-row-${rowId}`,
};
